import { Component } from '@angular/core';
import { AuthandregistryService } from '../../service/authandregistry.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';

@Component({
  selector: 'app-pw-setnew',
  standalone: false,

  templateUrl: './pw-setnew.component.html',
  styleUrl: './pw-setnew.component.scss'
})
export class PwSetnewComponent {
  hidespinner: boolean = true;
  setpwForm: FormGroup;
  resetId: string = ""


  constructor(
    private authService: AuthandregistryService,
    private _fb: FormBuilder,
    private router: Router,
  ) {
    // get ResetId from URL
    this.resetId = window.location.pathname.split('/')[3];
    this.setpwForm = this._fb.group({
      password: ['', Validators.required],
    });
  }
  async onSubmit() {
    if (this.setpwForm.invalid || typeof this.setpwForm.value.password !== 'string') return;

    this.hidespinner = false;
    let result = await this.authService.setNewPassword(this.resetId, this.setpwForm.value.password);
    this.hidespinner = true;

    if (result === true) {
      this.router.navigate(['home']);
    }

  }


}
